export function isCloudRecordingType(recType: string = ''): boolean {
  const recTypes = recType.split(',');
  return recTypes.some(
    (type) =>
      type === 'cloud' || type === 'cloud-beta' || type === 'cloud-audio-only'
  );
}
